export const translations = {
  "en": {
    "nav": {
      "dashboard": "Dashboard",
      "clients": "Clients",
      "transactions": "Transactions",
      "money": "Money",
      "targets": "Targets",
      "documents": "Documents",
      "offices": "Offices",
      "users": "Users",
      "analytics": "Analytics",
      "affiliates": "Affiliates",
      "calendar": "Calendar",
      "hierarchy": "Hierarchy",
      "settings": "Settings",
      "menu": "Menu"
    },
    "login": {
      "title": "Login",
      "email": "Email",
      "password": "Password",
      "rememberMe": "Remember me",
      "forgotPassword": "Forgot Password?",
      "signIn": "Sign In",
      "loginSuccess": "Login Successful",
      "welcomeMessage": "Welcome to Elite Technologies CRM",
      "loginFailed": "Login Failed",
      "invalidCredentials": "Invalid email or password",
      "inactiveUser": "This user account is inactive",
      "accessDenied": "Access is denied for this network",
      "tooManyAttempts": "Too many attempts. Please try again later",
      "unavailable": "Login service is unavailable. Please try again"
    },
    "dashboard": {
      "totalDeposits": "Total Deposits $",
      "totalWithdrawals": "Total Withdrawals $",
      "net": "Net $",
      "thisMonth": "This month",
      "productivityTracker": "Productivity Tracker",
      "trafficTracker": "Traffic Tracker",
      "turnoverTrend": "Turnover Trend",
      "todaySnapshot": "Today Snapshot",
      "transactionsThisMonth": "Transactions This Month",
      "sevenDayBreakdown": "7-Day Breakdown",
      "timeframe": "Timeframe",
      "today": "Today",
      "yesterday": "Yesterday",
      "thisMonthRow": "This Month",
      "lastMonth": "Last Month",
      "total": "Total",
      "clientsCount": "Clients #",
      "conversionPercent": "Conv.%",
      "transactions": "transactions",
      "payments": "payments",
      "todayBalance": "today balance",
      "netAmount": "net $",
      "approved": "Approved",
      "pending": "Pending",
      "declined": "Declined",
      "deposit": "Deposit",
      "withdrawal": "Withdrawal",
      "deposits": "Deposits",
      "withdrawals": "Withdrawals",
      "copyright": "COPYRIGHT (C) 2026 Abramov CRM. All rights reserved."
    },
    "analytics": {
      "period": "Period",
      "to": "to",
      "fromDate": "From",
      "toDate": "To",
      "all": "All",
      "metrics": "Metrics",
      "summaryMetrics": "Summary metrics",
      "chooseSummaryMetrics": "Choose summary metrics",
      "columnsButton": "Columns",
      "visibleColumns": "Visible columns",
      "chooseVisibleColumns": "Choose visible columns",
      "export": "Export",
      "refresh": "Refresh",
      "loading": "Loading...",
      "clients": "Clients",
      "transactions": "transactions",
      "payments": "payments",
      "depositsLower": "deposits",
      "statusesLower": "statuses",
      "selectedStatusClients": "selected status clients",
      "noStatuses": "No statuses",
      "noSalesStatusesConfigured": "No sales statuses configured",
      "noRetentionStatusesConfigured": "No retention statuses configured",
      "noDepositsInPeriod": "No deposits in period",
      "noData": "No data",
      "noDataForPeriod": "No data for this period",
      "noStatusAnalyticsYet": "No status analytics yet",
      "noFinanceAnalyticsYet": "No financial data yet",
      "noClientDetails": "No client details for this period",
      "clientDetailsHint": "Showing up to 200 clients. Click a row to open the client card.",
      "failedLoad": "Failed to load analytics",
      "startBeforeEnd": "Start date must be before end date.",
      "clientDetailsUnavailable": "Client details are unavailable",
      "visibleToYou": "visible to you",
      "registeredInPeriod": "registered in period",
      "currentlyActive": "currently active",
      "redepositsDepositors": "redeposits / depositors",
      "completedDeposits": "completed deposits",
      "pvClients": "PV / clients",
      "newToDeposit": "New to Deposit",
      "depositsMinusWithdrawals": "deposits minus withdrawals",
      "ofPeriodClients": "of period clients",
      "newToFtdToRedep": "new to FTD to ReDep",
      "pvLeadersInPeriod": "PV leaders in period",
      "selectedSalesStatuses": "selected sales statuses",
      "selectedRetentionStatuses": "selected retention statuses",
      "conversionFunnel": "Conversion Funnel",
      "topAgents": "Top Agents",
      "salesStatusesPie": "Sales Statuses Pie",
      "retentionStatusesPie": "Retention Statuses Pie",
      "new": "New",
      "from": "from",
      "zeroFromPrevious": "0% from previous",
      "depositors": "Depositors",
      "redeposits": "Redeposits",
      "metric": "Metric",
      "value": "Value",
      "presets": {
        "Today": "Today",
        "Yesterday": "Yesterday",
        "ThisWeek": "This Week",
        "LastWeek": "Last Week",
        "ThisMonth": "This Month",
        "LastMonth": "Last Month",
        "Last3M": "Last 3M",
        "Last6M": "Last 6M",
        "ThisYear": "This Year",
        "Custom": "Custom"
      },
      "tabs": {
        "affiliates": "Affiliates",
        "clients": "Clients",
        "statuses": "Statuses",
        "finance": "Finance",
        "departments": "Departments"
      },
      "departmentLevels": {
        "desks": "Desks",
        "teams": "Teams",
        "agents": "Agents"
      },
      "kpi": {
        "clients": "Clients",
        "leads": "Leads",
        "newClients": "New Clients",
        "activeClients": "Active Clients",
        "conversionRate": "New -> Deposit CR",
        "noAnswerRate": "Never Answer %",
        "invalidRate": "Invalid %",
        "redepositRate": "ReDep Rate",
        "avgPv": "Avg PV",
        "deposits": "Deposits",
        "withdrawals": "Withdrawals",
        "net": "Net",
        "topStatus": "Top Status"
      },
      "columns": {
        "groupName": "Name",
        "affiliate": "Affiliate",
        "funnel": "Funnel",
        "clients": "Clients",
        "newClients": "New Clients",
        "activeClients": "Active Clients",
        "paidClients": "Paid Clients",
        "cr": "CR %",
        "noAnswerRate": "Never Answer %",
        "invalidRate": "Invalid %",
        "ftd": "FTD",
        "ftdAmount": "FTD $",
        "redeposits": "Redeposits",
        "redepositsAmount": "ReDep $",
        "pv": "PV",
        "avgPv": "Avg PV",
        "clientId": "ID",
        "name": "Client",
        "status": "Status",
        "agent": "Agent",
        "percentOfAll": "% of Total",
        "delta": "Delta",
        "currency": "Currency",
        "numDeposits": "# Deposits",
        "deposits": "Deposits",
        "numWithdrawals": "# Withdrawals",
        "withdrawals": "Withdrawals",
        "net": "Net",
        "payments": "# Payments"
      }
    },
    "clients": {
      "filters": "Filters",
      "metrics": "Metrics",
      "import": "Import",
      "export": "Export",
      "new": "New",
      "id": "ID",
      "active": "Active",
      "office": "Office",
      "firstName": "First Name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "status": "Status",
      "language": "Language",
      "country": "Country",
      "department": "Department",
      "agent": "Agent",
      "credits": "Credits",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "entries": "entries",
      "page": "Page",
      "yes": "Yes",
      "no": "No",
      "resetAll": "Reset All",
      "selectAll": "Select All",
      "searchPlaceholder": "ID / name / email / phone",
      "allStatuses": "All Statuses",
      "allCountries": "All Countries",
      "allOffices": "All Offices",
      "allAgents": "All Agents",
      "allLanguages": "All Languages",
      "activeAndInactive": "Active & Inactive",
      "activeOnly": "Active only",
      "inactiveOnly": "Inactive only",
      "applyFilters": "Apply Filters",
      "appliedFilters": "Applied filters",
      "pendingFilters": "Changes not applied",
      "filterPresets": "Filter presets",
      "selectPreset": "Select preset",
      "presetName": "Preset name",
      "savePreset": "Save preset",
      "deletePreset": "Delete preset",
      "presetSaved": "Filter preset saved",
      "presetDeleted": "Filter preset deleted",
      "presetNameRequired": "Enter a preset name",
      "filterSearch": "Search",
      "removeFilter": "Remove filter",
      "reset": "Reset",
      "noClientsFound": "No clients found",
      "actionsLabel": "Actions",
      "duplicates": "Duplicates",
      "duplicatesTitle": "Duplicate clients",
      "duplicatesHint": "Find matching client records within the clients you can access.",
      "duplicateChooseCriterion": "Search for duplicates by",
      "duplicateName": "Name",
      "duplicateNameHint": "Same full name",
      "duplicatePhone": "Phone",
      "duplicatePhoneHint": "Same phone number",
      "duplicateEmail": "Email",
      "duplicateEmailHint": "Same email address",
      "duplicateSearch": "Search",
      "duplicateSearching": "Searching…",
      "duplicateReady": "Choose a criterion and start the search.",
      "duplicateResults": "Duplicate groups",
      "closeDuplicates": "Close duplicate search",
      "duplicatesEmpty": "No duplicates found",
      "duplicatesEmptyHint": "Try searching by another criterion.",
      "duplicatesGroups": "duplicate group(s)",
      "dupByEmail": "Same email",
      "dupByPhone": "Same phone",
      "dupByName": "Same name",
      "mergeKeep": "Keep",
      "merge": "Merge",
      "mergeConfirm": "This deletes the other record(s) and moves their transactions, documents and history onto the kept client. This cannot be undone.",
      "mergeConfirmBtn": "Confirm merge",
      "mergeCancel": "Cancel",
      "mergeDone": "Clients merged",
      "mergeReviewTitle": "Review and merge",
      "mergeReviewHint": "Choose the final client record and the values to keep.",
      "mergeReviewButton": "Review & merge {count}",
      "mergeBack": "Back to duplicate groups",
      "mergeBaseTitle": "Client record to keep",
      "mergeBaseHint": "This record keeps its ID. Transactions, documents, comments, agent notes, chats, and case history from every duplicate will be moved to it.",
      "mergeRecords": "records",
      "mergeKeptId": "Keeps ID",
      "mergeValuesTitle": "Values to keep",
      "mergeValuesHint": "Only fields with different non-empty values require a choice. Matching and missing values are handled automatically.",
      "mergeNoConflicts": "These records have no conflicting profile values.",
      "mergeDeleteWarning": "All comments and related history will be preserved. Then {count} duplicate record(s) will be permanently deleted. This cannot be undone.",
      "mergeInProgress": "Merging…",
      "mergeDetailsLoading": "Loading client details…",
      "mergeDetailsFailed": "Failed to load client details",
      "mergeFields": {
        "firstName": "First name",
        "lastName": "Last name",
        "email": "Email",
        "email2": "Email 2",
        "phone": "Phone",
        "phone2": "Phone 2",
        "mobile": "Mobile",
        "birthdate": "Birthdate",
        "gender": "Gender",
        "sin": "SIN",
        "passport": "Passport",
        "office": "Office",
        "department": "Department",
        "agent": "Agent",
        "desk": "Desk",
        "team": "Team",
        "status": "Status",
        "salesAgent": "Sales agent",
        "salesStatus": "Sales status",
        "salesDesk": "Sales desk",
        "salesTeam": "Sales team",
        "retAgent": "Retention agent",
        "retStatus": "Retention status",
        "retDesk": "Retention desk",
        "retTeam": "Retention team",
        "language": "Language",
        "country": "Country",
        "address": "Address",
        "city": "City",
        "state": "State",
        "credits": "Credits",
        "source": "Source",
        "referral": "Referral",
        "funnel": "Funnel",
        "affiliate": "Affiliate",
        "registrationIp": "Registration IP",
        "ext_id": "External ID"
      },
      "columns": {
        "id": "ID",
        "active": "Active",
        "office": "Office",
        "client": "Client",
        "firstName": "First Name",
        "lastName": "Last name",
        "email": "Email",
        "phone": "Phone",
        "salesStatus": "Sales Status",
        "retStatus": "Retention Status",
        "language": "Language",
        "country": "Country",
        "department": "Department",
        "agent": "Agent",
        "balance": "Balance",
        "affiliate": "Affiliate",
        "lastComment": "Last Comment",
        "lastCommentDate": "Last Comment Date",
        "withdrawals": "Withdrawals",
        "currency": "Currency",
        "totalDeposits": "Total Deposits",
        "lastLogin": "Last login client",
        "registeredAt": "Registered At",
        "registrationIp": "Registration IP",
        "funnel": "Funnel",
        "additionalInfo": "Additional Info"
      },
      "departments": {
        "sales": "sales",
        "retention": "retention"
      },
      "actions": {
        "assignTo": "Assign To",
        "blockLogin": "Block Client Login",
        "unblockLogin": "Unblock Client Login",
        "changeStatus": "Change Status",
        "changeOffice": "Change Office",
        "changeCountry": "Change Country",
        "changeLanguage": "Change Language",
        "deleteClients": "Delete Clients"
      }
    },
    "clientDetail": {
      "loading": "Loading...",
      "clientNotFound": "Client not found",
      "loadFailed": "Could not load the client. Please retry. If the error persists, contact your administrator.",
      "retry": "Retry",
      "backToClients": "Back to clients",
      "active": "Active",
      "blocked": "Blocked",
      "addCallback": "Add callback",
      "changeStatus": "Change Status",
      "refresh": "Refresh",
      "personalInformation": "Personal Information",
      "acquisitionStatus": "Acquisition Status",
      "pinnedNotes": "Pinned Notes",
      "noPinnedNotes": "No pinned notes",
      "comments": "Comments",
      "caseInfo": "Case Info",
      "transactions": "Transactions",
      "clientCabinet": "Client's Cabinet",
      "documents": "Documents",
      "personalInfo": "Personal Info",
      "newComment": "New Comment",
      "noCommentsYet": "No comments yet",
      "loadingComments": "Loading comments...",
      "loadOlderComments": "Load older comments",
      "configureVisibleFields": "Configure visible fields",
      "visibleFields": "Visible fields",
      "dateOfBirth": "Date of birth",
      "gender": "Gender",
      "phone": "Phone",
      "secondPhone": "Second Phone",
      "email": "Email",
      "secondEmail": "Second Email",
      "country": "Country",
      "citizenship": "Citizenship",
      "language": "Language",
      "city": "City",
      "address": "Address",
      "affiliate": "Affiliate",
      "affiliateId": "Affiliate ID",
      "source": "Source",
      "referral": "Referral",
      "funnel": "Funnel",
      "regIp": "Reg. IP",
      "callClient": "Call client",
      "inviteToConference": "Invite to conference / transfer",
      "endCall": "End call",
      "sales": "Sales",
      "retention": "Retention",
      "notAssigned": "Not assigned",
      "desk": "Desk",
      "team": "Team"
    },
    "transactions": {
      "loading": "Loading...",
      "filters": "Filters",
      "new": "New",
      "all": "All",
      "clearFilters": "Clear Filters",
      "id": "ID",
      "clientId": "Client ID",
      "type": "Type",
      "amount": "Amount",
      "currency": "Currency",
      "status": "Status",
      "description": "Description",
      "date": "Date",
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "period": "Period",
      "filteredTotal": "Filtered total",
      "transactionsCount": "Transactions",
      "periods": {
        "all": "All time",
        "today": "Today",
        "week": "This week",
        "month": "This month",
        "date": "Specific date",
        "range": "Date range"
      },
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "editTransaction": "Edit Transaction",
      "newTransaction": "New Transaction",
      "descriptionPlaceholder": "e.g. Wire transfer, card payment...",
      "update": "Update",
      "create": "Create",
      "failedLoad": "Failed to load transactions",
      "exported": "Exported to {format}",
      "exportFailed": "Export failed",
      "transactionUpdated": "Transaction updated",
      "transactionCreated": "Transaction created",
      "operationFailed": "Operation failed",
      "confirmDelete": "Delete this transaction?",
      "transactionDeleted": "Transaction deleted",
      "deleteFailed": "Delete failed",
      "types": {
        "deposit": "Deposit",
        "withdrawal": "Withdrawal"
      },
      "statuses": {
        "completed": "Completed",
        "pending": "Pending",
        "rejected": "Rejected",
        "failed": "Failed"
      }
    },
    "affiliates": {
      "new": "New",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "searchPlaceholder": "Search by name...",
      "loading": "Loading...",
      "empty": "No affiliates found",
      "edit": "Edit",
      "integrationInfo": "Integration Info",
      "copyToken": "Copy Token",
      "changeToken": "Change Token",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "entries": "entries",
      "editAffiliate": "Edit Affiliate",
      "addAffiliate": "Add New Affiliate",
      "name": "Name",
      "office": "Office",
      "namePlaceholder": "Type Affiliate Name",
      "officePlaceholder": "Select Office",
      "cancel": "Cancel",
      "save": "Save",
      "integration": "Integration",
      "leadEndpoint": "Lead Intake Endpoint",
      "requestBody": "Request Body (JSON)",
      "copyCurl": "Copy cURL example",
      "response": "Response",
      "close": "Close",
      "confirm": "Confirm",
      "changeTokenConfirm": "Are you sure you want to change the token? The old token will be invalidated.",
      "failedLoad": "Failed to load affiliates",
      "failedLoadOffices": "Failed to load offices",
      "nameRequired": "Name required",
      "officeRequired": "Office required",
      "noOffices": "No offices available",
      "updated": "Affiliate updated",
      "created": "Affiliate created",
      "saveFailed": "Save failed",
      "failed": "Failed",
      "tokenChanged": "Token changed",
      "tokenChangeFailed": "Failed to change token",
      "tokenCopied": "Token copied",
      "copyFailed": "Copy failed",
      "copied": "Copied",
      "urlCopied": "URL copied",
      "curlCopied": "cURL copied",
      "columns": {
        "id": "ID",
        "name": "Name",
        "office": "Office",
        "status": "Status",
        "apiToken": "API Token",
        "createdAt": "Created At",
        "actions": "Actions"
      }
    },
    "documents": {
      "uploadDocument": "Upload Document",
      "filters": "Filters",
      "documents": "documents",
      "searchLabel": "Search (client name / email / file)",
      "searchPlaceholder": "Type and press Enter...",
      "documentType": "Document Type",
      "allTypes": "All Types",
      "status": "Status",
      "allStatuses": "All Statuses",
      "apply": "Apply",
      "clear": "Clear",
      "client": "Client",
      "file": "File",
      "visibility": "Visibility",
      "reviewStatus": "Review Status",
      "uploadedBy": "Uploaded By",
      "date": "Date",
      "actions": "Actions",
      "loading": "Loading...",
      "empty": "No documents yet",
      "emptyPendingClient": "Pending client uploads will appear here",
      "emptyPendingCrm": "Pending CRM uploads will appear here",
      "emptyClientUploads": "Client uploads will appear here",
      "emptyCrmUploads": "Upload a document using the button above",
      "clientPortal": "Client upload",
      "crmUpload": "CRM upload",
      "previewDocument": "Preview document",
      "splitPdf": "Split PDF",
      "download": "Download",
      "approve": "Approve",
      "declineAndDelete": "Decline and delete",
      "resetToPending": "Reset to Pending",
      "delete": "Delete",
      "of": "of",
      "uploadHint": "Attach a document to the client's profile",
      "fileHint": "(PDF, JPG, PNG - max 10 MB)",
      "clickToReplace": "click to replace",
      "dropFile": "Drop file here or click to browse",
      "cancel": "Cancel",
      "upload": "Upload",
      "uploading": "Uploading...",
      "searchClient": "Search client by name or email...",
      "searching": "Searching...",
      "sourceTabs": {
        "pending": "Pending",
        "client": "Client uploads",
        "crm": "CRM documents"
      },
      "pendingSourceTabs": {
        "client": "Client uploads",
        "crm": "CRM uploads"
      },
      "statuses": {
        "pending": "Pending",
        "approved": "Approved",
        "declined": "Declined"
      },
      "docTypes": {
        "Passport": "Passport",
        "Driver License": "Driver License",
        "ID Front": "ID Front",
        "ID Back": "ID Back",
        "Utility Bill": "Utility Bill",
        "Bank Statement": "Bank Statement",
        "Contract": "Contract",
        "Other": "Other",
        "file": "File",
        "invoice": "Invoice",
        "case_file": "Case File"
      }
    },
    "calendar": {
      "loading": "Loading...",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "upcomingEvents": "Upcoming Events",
      "allAgents": "All Agents",
      "workHoursSettings": "Work Hours Settings",
      "addEvent": "Add Event",
      "noUpcomingEvents": "No upcoming events",
      "more": "+{count} more",
      "allDay": "All Day",
      "markDone": "Mark done",
      "markMissed": "Mark missed",
      "editEvent": "Edit Event",
      "newEvent": "New Event",
      "title": "Title",
      "eventTitlePlaceholder": "Event title",
      "type": "Type",
      "startDate": "Start Date",
      "startTime": "Start Time",
      "endTime": "End Time",
      "clientName": "Client Name",
      "assignTo": "Assign To",
      "unassigned": "Unassigned",
      "description": "Description",
      "status": "Status",
      "optional": "Optional",
      "optionalNotes": "Optional notes...",
      "delete": "Delete",
      "deleting": "Deleting...",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving...",
      "workDayHours": "Work Day Hours",
      "workDayStart": "Work Day Start",
      "workDayEnd": "Work Day End",
      "titleRequired": "Title is required",
      "eventUpdated": "Event updated",
      "eventCreated": "Event created",
      "saveFailed": "Failed to save event",
      "eventDeleted": "Event deleted",
      "deleteFailed": "Failed to delete event",
      "markedAs": "Marked as {status}",
      "statusUpdateFailed": "Failed to update status",
      "failedLoad": "Failed to load events",
      "startBeforeEnd": "Start must be before end",
      "workHoursSaved": "Work hours saved",
      "views": {
        "month": "Month",
        "week": "Week",
        "day": "Day",
        "list": "List"
      },
      "types": {
        "call": "Call",
        "reminder": "Reminder",
        "meeting": "Meeting",
        "other": "Other"
      },
      "statuses": {
        "pending": "Pending",
        "done": "Done",
        "missed": "Missed"
      },
      "months": {
        "0": "January",
        "1": "February",
        "2": "March",
        "3": "April",
        "4": "May",
        "5": "June",
        "6": "July",
        "7": "August",
        "8": "September",
        "9": "October",
        "10": "November",
        "11": "December"
      },
      "daysShort": {
        "0": "Mon",
        "1": "Tue",
        "2": "Wed",
        "3": "Thu",
        "4": "Fri",
        "5": "Sat",
        "6": "Sun"
      },
      "daysFull": {
        "0": "Monday",
        "1": "Tuesday",
        "2": "Wednesday",
        "3": "Thursday",
        "4": "Friday",
        "5": "Saturday",
        "6": "Sunday"
      }
    },
    "hierarchy": {
      "title": "Hierarchy",
      "loading": "Loading hierarchy...",
      "subtitle": "Drag agents between teams - Click to collapse/expand - Click a role to change it",
      "offices": "offices",
      "desks": "desks",
      "teams": "teams",
      "agents": "agents",
      "people": "people",
      "refresh": "Refresh",
      "global": "Global",
      "noHead": "No head",
      "empty": "Empty",
      "dropHere": "Drop here",
      "clickChangeRole": "Click to change role",
      "emptyTitle": "No hierarchy yet",
      "emptySubtitle": "Create offices, desks, teams and assign users to get started.",
      "failedLoad": "Failed to load hierarchy",
      "moveFailed": "Move failed",
      "failed": "Failed"
    },
    "offices": {
      "tabs": {
        "offices": "Offices",
        "desks": "Desks",
        "teams": "Teams",
        "users": "Users"
      },
      "new": "New",
      "newDesk": "New Desk",
      "newTeam": "New Team",
      "active": "Active",
      "inactive": "Inactive",
      "filters": "Filters",
      "apply": "Apply",
      "clear": "Clear",
      "loading": "Loading...",
      "entries": "entries",
      "name": "Name",
      "office": "Office",
      "desk": "Desk",
      "department": "Department",
      "officeName": "Office Name",
      "deskName": "Desk Name",
      "teamName": "Team Name",
      "enterValue": "Enter Value",
      "allOffices": "All Offices",
      "allDesks": "All Desks",
      "selectOffice": "Select Office",
      "selectOfficeFirst": "Select Office first",
      "notSpecified": "Not specified",
      "typeOfficeName": "Type Office Name",
      "typeDeskName": "Type Desk Name",
      "typeTeamName": "Type Team Name",
      "noOffices": "No offices found",
      "noDesks": "No desks found",
      "noTeams": "No teams found",
      "editOffice": "Edit Office",
      "addOffice": "Add New Office",
      "editDesk": "Edit Desk",
      "addDesk": "Add New Desk",
      "editTeam": "Edit Team",
      "addTeam": "Add New Team",
      "cancel": "Cancel",
      "save": "Save",
      "saveFailed": "Save failed",
      "deleteFailed": "Delete failed",
      "failedLoadOffices": "Failed to load offices",
      "failedLoadDesks": "Failed to load desks",
      "failedLoadTeams": "Failed to load teams",
      "officeNameRequired": "Office name required",
      "deskNameRequired": "Desk name required",
      "teamNameRequired": "Team name required",
      "createDeskFirst": "Create and select a desk before creating a team",
      "officeUpdated": "Office updated",
      "officeCreated": "Office created",
      "officeDeleted": "Office deleted",
      "deskUpdated": "Desk updated",
      "deskCreated": "Desk created",
      "deskDeleted": "Desk deleted",
      "teamUpdated": "Team updated",
      "teamCreated": "Team created",
      "teamDeleted": "Team deleted",
      "updatedOfficeTeams": "Updated office for {count} team(s)",
      "confirmDeleteOffice": "Delete office \"{name}\"?",
      "confirmDeleteDesk": "Delete desk \"{name}\"?",
      "confirmDeleteTeam": "Delete team \"{name}\"?",
      "columns": {
        "id": "ID",
        "name": "Name",
        "usersCount": "Users #",
        "clientsCount": "Clients #",
        "creationDate": "Creation Date",
        "office": "Office",
        "created": "Created",
        "department": "Department",
        "desk": "Desk",
        "actions": "Actions"
      }
    },
    "settings": {
      "tabs": {
        "statuses": "Statuses",
        "telephony": "Telephony Connections",
        "permissions": "Permissions",
        "whitelist": "IP Whitelist",
        "blacklist": "IP Blacklist",
        "sessions": "Sessions",
        "logs": "Logs"
      },
      "statuses": {
        "dragPrefix": "Drag",
        "dragSuffix": "to reorder",
        "addStatus": "Add Status",
        "statusesTitle": "Statuses",
        "loading": "Loading...",
        "empty": "No statuses yet",
        "default": "Default",
        "statusesCount": "statuses",
        "editStatus": "Edit Status",
        "newStatus": "New Status",
        "name": "Name",
        "namePlaceholder": "e.g. Follow UP",
        "color": "Color",
        "setAsDefault": "Set as default",
        "cancel": "Cancel",
        "save": "Save",
        "failedLoad": "Failed to load statuses",
        "orderSaveFailed": "Failed to save order",
        "nameRequired": "Name is required",
        "statusUpdated": "Status updated",
        "statusCreated": "Status created",
        "statusSaveFailed": "Failed to save status",
        "confirmDelete": "Delete status \"{name}\"?",
        "deleted": "Deleted",
        "deleteFailed": "Failed to delete",
        "columns": {
          "badge": "Badge",
          "name": "Name",
          "default": "Default",
          "actions": "Actions"
        }
      }
    },
    "users": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive",
      "new": "New",
      "filters": "Filters",
      "users": "users",
      "search": "Search",
      "searchPlaceholder": "Name or email",
      "role": "Role",
      "allRoles": "All roles",
      "office": "Office",
      "allOffices": "All offices",
      "desk": "Desk",
      "allDesks": "All desks",
      "team": "Team",
      "allTeams": "All teams",
      "selectOffice": "Select office",
      "selectDesk": "Select desk",
      "selectTeam": "Select Team",
      "selectParentFirst": "select parent first",
      "apply": "Apply",
      "clear": "Clear",
      "loading": "Loading...",
      "noUsers": "No users found",
      "enabled": "enabled",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "showing": "Showing",
      "of": "of",
      "editUser": "Edit User",
      "newUser": "New User",
      "name": "Name",
      "fullName": "Full name",
      "password": "Password",
      "newPassword": "New password",
      "keepPassword": "Leave blank to keep current password",
      "telephonyAccess": "Telephony access",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving...",
      "failedLoad": "Failed to load users",
      "nameEmailRequired": "Name and email required",
      "createTeamFirst": "Create and select a team before creating an agent",
      "passwordRequired": "Password required",
      "saveFailed": "Save failed",
      "userUpdated": "User updated",
      "userCreated": "User created",
      "userActivated": "User activated",
      "userDeactivated": "User deactivated",
      "statusUpdateFailed": "Failed to update status",
      "confirmDelete": "Delete user {name}?",
      "userDeleted": "User deleted",
      "deleteFailed": "Delete failed",
      "columns": {
        "id": "ID",
        "userName": "User Name",
        "email": "Email",
        "role": "Role",
        "office": "Office",
        "desk": "Desk",
        "team": "Team",
        "telephony": "Telephony",
        "clients": "Clients",
        "lastLogin": "Last Login",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "placeholder": {
      "underConstruction": "This page is under construction. Feature coming soon!"
    }
  },
  "ru": {
    "nav": {
      "dashboard": "Дашборд",
      "clients": "Клиенты",
      "transactions": "Транзакции",
      "money": "Money",
      "targets": "Targets",
      "documents": "Документы",
      "offices": "Офисы",
      "users": "Пользователи",
      "analytics": "Аналитика",
      "affiliates": "Партнёры",
      "calendar": "Календарь",
      "hierarchy": "Иерархия",
      "settings": "Настройки",
      "menu": "Меню"
    },
    "login": {
      "title": "Вход",
      "email": "Email",
      "password": "Пароль",
      "rememberMe": "Запомнить меня",
      "forgotPassword": "Забыли пароль?",
      "signIn": "Войти",
      "loginSuccess": "Вход выполнен",
      "welcomeMessage": "Добро пожаловать в Elite Technologies CRM",
      "loginFailed": "Ошибка входа",
      "invalidCredentials": "Неверный email или пароль",
      "inactiveUser": "Эта учётная запись отключена",
      "accessDenied": "Доступ из этой сети запрещён",
      "tooManyAttempts": "Слишком много попыток. Попробуйте позже",
      "unavailable": "Сервис входа недоступен. Попробуйте ещё раз"
    },
    "dashboard": {
      "totalDeposits": "Всего депозитов $",
      "totalWithdrawals": "Всего выводов $",
      "net": "Чистый итог $",
      "thisMonth": "В этом месяце",
      "productivityTracker": "Трекер продуктивности",
      "trafficTracker": "Трекер трафика",
      "turnoverTrend": "Тренд оборота",
      "todaySnapshot": "Сводка за сегодня",
      "transactionsThisMonth": "Транзакции за месяц",
      "sevenDayBreakdown": "Разбивка за 7 дней",
      "timeframe": "Период",
      "today": "Сегодня",
      "yesterday": "Вчера",
      "thisMonthRow": "Этот месяц",
      "lastMonth": "Прошлый месяц",
      "total": "Всего",
      "clientsCount": "Клиенты #",
      "conversionPercent": "Конв.%",
      "transactions": "транзакций",
      "payments": "платежей",
      "todayBalance": "баланс за сегодня",
      "netAmount": "нетто $",
      "approved": "Одобрено",
      "pending": "В ожидании",
      "declined": "Отклонено",
      "deposit": "Депозит",
      "withdrawal": "Вывод",
      "deposits": "Депозиты",
      "withdrawals": "Выводы",
      "copyright": "Copyright (C) 2026 Abramov CRM. All rights reserved."
    },
    "analytics": {
      "period": "Период",
      "to": "до",
      "fromDate": "С",
      "toDate": "По",
      "all": "Все",
      "metrics": "Метрики",
      "summaryMetrics": "Сводные метрики",
      "chooseSummaryMetrics": "Выбрать сводные метрики",
      "columnsButton": "Колонки",
      "visibleColumns": "Видимые колонки",
      "chooseVisibleColumns": "Выбрать видимые колонки",
      "export": "Экспорт",
      "refresh": "Обновить",
      "loading": "Загрузка...",
      "clients": "Клиенты",
      "transactions": "транзакций",
      "payments": "платежей",
      "depositsLower": "депозитов",
      "statusesLower": "статусы",
      "selectedStatusClients": "клиенты выбранных статусов",
      "noStatuses": "Статусов нет",
      "noSalesStatusesConfigured": "Sales статусы не настроены",
      "noRetentionStatusesConfigured": "Retention статусы не настроены",
      "noDepositsInPeriod": "Нет депозитов за период",
      "noData": "Нет данных",
      "noDataForPeriod": "Нет данных за этот период",
      "noStatusAnalyticsYet": "Статистики по статусам пока нет",
      "noFinanceAnalyticsYet": "Финансовых данных пока нет",
      "noClientDetails": "Нет деталей клиентов за этот период",
      "clientDetailsHint": "Показано до 200 клиентов. Нажмите строку, чтобы открыть карточку клиента.",
      "failedLoad": "Не удалось загрузить аналитику",
      "startBeforeEnd": "Дата начала должна быть раньше даты окончания.",
      "clientDetailsUnavailable": "Детали клиентов недоступны",
      "visibleToYou": "видимые вам",
      "registeredInPeriod": "зарегистрированы за период",
      "currentlyActive": "сейчас активны",
      "redepositsDepositors": "редепозиты / депозиторы",
      "completedDeposits": "завершённые депозиты",
      "pvClients": "PV / клиенты",
      "depositsMinusWithdrawals": "депозиты минус выводы",
      "ofPeriodClients": "клиентов за период",
      "newToFtdToRedep": "от новых к FTD и ReDep",
      "pvLeadersInPeriod": "лидеры PV за период",
      "selectedSalesStatuses": "выбранные Sales статусы",
      "selectedRetentionStatuses": "выбранные Retention статусы",
      "conversionFunnel": "Воронка конверсии",
      "topAgents": "Топ агентов",
      "salesStatusesPie": "Sales статусы",
      "retentionStatusesPie": "Retention статусы",
      "new": "Новые",
      "from": "от",
      "zeroFromPrevious": "0% от предыдущего",
      "depositors": "Депозиторы",
      "redeposits": "Редепозиты",
      "metric": "Метрика",
      "value": "Значение",
      "presets": {
        "Today": "Сегодня",
        "Yesterday": "Вчера",
        "ThisWeek": "Эта неделя",
        "LastWeek": "Прошлая неделя",
        "ThisMonth": "Этот месяц",
        "LastMonth": "Прошлый месяц",
        "Last3M": "Последние 3 мес.",
        "Last6M": "Последние 6 мес.",
        "ThisYear": "Этот год",
        "Custom": "Свой период"
      },
      "tabs": {
        "affiliates": "Партнёры",
        "clients": "Клиенты",
        "statuses": "Статусы",
        "finance": "Финансы",
        "departments": "Departments"
      },
      "departmentLevels": {
        "desks": "Desks",
        "teams": "Teams",
        "agents": "Agents"
      },
      "kpi": {
        "clients": "Клиенты",
        "newClients": "Новые клиенты",
        "activeClients": "Активные клиенты",
        "redepositRate": "ReDep Rate",
        "avgPv": "Средний PV",
        "deposits": "Депозиты",
        "withdrawals": "Выводы",
        "net": "Нетто",
        "topStatus": "Топ статус"
      },
      "columns": {
        "groupName": "Name",
        "affiliate": "Партнёр",
        "funnel": "Воронка",
        "clients": "Клиенты",
        "newClients": "New Clients",
        "activeClients": "Active Clients",
        "paidClients": "Paid Clients",
        "cr": "CR %",
        "ftd": "FTD",
        "ftdAmount": "FTD $",
        "redeposits": "Редепозиты",
        "redepositsAmount": "ReDep $",
        "pv": "PV",
        "avgPv": "Средний PV",
        "clientId": "ID",
        "name": "Клиент",
        "status": "Статус",
        "agent": "Агент",
        "percentOfAll": "% от всего",
        "delta": "Дельта",
        "currency": "Валюта",
        "numDeposits": "# депозитов",
        "deposits": "Депозиты",
        "numWithdrawals": "# выводов",
        "withdrawals": "Выводы",
        "net": "Нетто",
        "payments": "# платежей"
      }
    },
    "clients": {
      "filters": "Фильтры",
      "metrics": "Метрики",
      "import": "Импорт",
      "export": "Экспорт",
      "new": "Новый",
      "id": "ID",
      "active": "Активен",
      "office": "Офис",
      "firstName": "Имя",
      "lastName": "Фамилия",
      "email": "Email",
      "phone": "Телефон",
      "status": "Статус",
      "language": "Язык",
      "country": "Страна",
      "department": "Отдел",
      "agent": "Агент",
      "credits": "Кредиты",
      "showing": "Показано",
      "to": "-",
      "of": "из",
      "entries": "записей",
      "page": "Страница",
      "yes": "Да",
      "no": "Нет",
      "resetAll": "Сбросить всё",
      "selectAll": "Выбрать всё",
      "searchPlaceholder": "ID / имя / email / телефон",
      "allStatuses": "Все статусы",
      "allCountries": "Все страны",
      "allOffices": "Все офисы",
      "allAgents": "Все агенты",
      "allLanguages": "Все языки",
      "activeAndInactive": "Активные и неактивные",
      "activeOnly": "Только активные",
      "inactiveOnly": "Только неактивные",
      "applyFilters": "Применить фильтры",
      "appliedFilters": "Применённые фильтры",
      "pendingFilters": "Изменения не применены",
      "filterPresets": "Пресеты фильтров",
      "selectPreset": "Выберите пресет",
      "presetName": "Название пресета",
      "savePreset": "Сохранить пресет",
      "deletePreset": "Удалить пресет",
      "presetSaved": "Пресет фильтров сохранён",
      "presetDeleted": "Пресет фильтров удалён",
      "presetNameRequired": "Введите название пресета",
      "filterSearch": "Поиск",
      "removeFilter": "Снять фильтр",
      "reset": "Сбросить",
      "noClientsFound": "Клиенты не найдены",
      "actionsLabel": "Действия",
      "duplicates": "Дубликаты",
      "duplicatesTitle": "Дубликаты клиентов",
      "duplicatesHint": "Найдите совпадающие записи среди доступных вам клиентов.",
      "duplicateChooseCriterion": "Искать дубликаты по",
      "duplicateName": "Имени",
      "duplicateNameHint": "Совпадает полное имя",
      "duplicatePhone": "Телефону",
      "duplicatePhoneHint": "Совпадает номер телефона",
      "duplicateEmail": "Email",
      "duplicateEmailHint": "Совпадает email-адрес",
      "duplicateSearch": "Поиск",
      "duplicateSearching": "Ищем…",
      "duplicateReady": "Выберите критерий и запустите поиск.",
      "duplicateResults": "Группы дубликатов",
      "closeDuplicates": "Закрыть поиск дубликатов",
      "duplicatesEmpty": "Дубликаты не найдены",
      "duplicatesEmptyHint": "Попробуйте поискать по другому критерию.",
      "duplicatesGroups": "групп(ы)",
      "dupByEmail": "Одинаковый email",
      "dupByPhone": "Одинаковый телефон",
      "dupByName": "Одинаковое ФИО",
      "mergeKeep": "Оставить",
      "merge": "Объединить",
      "mergeConfirm": "Остальные записи будут удалены, а их транзакции, документы и история перенесены на оставленного клиента. Отменить нельзя.",
      "mergeConfirmBtn": "Подтвердить объединение",
      "mergeCancel": "Отмена",
      "mergeDone": "Клиенты объединены",
      "mergeReviewTitle": "Проверка и объединение",
      "mergeReviewHint": "Выберите итоговую запись клиента и значения, которые нужно сохранить.",
      "mergeReviewButton": "Проверить и объединить: {count}",
      "mergeBack": "Вернуться к группам дубликатов",
      "mergeBaseTitle": "Запись клиента, которую нужно оставить",
      "mergeBaseHint": "У этой записи сохранится ID. В неё будут перенесены транзакции, документы, все комментарии, заметки агентов, чат и история кейса из каждого дубля.",
      "mergeRecords": "записей",
      "mergeKeptId": "ID останется",
      "mergeValuesTitle": "Значения, которые нужно сохранить",
      "mergeValuesHint": "Выбор нужен только для полей с разными заполненными значениями. Совпадающие и пустые поля обрабатываются автоматически.",
      "mergeNoConflicts": "В профилях этих клиентов нет конфликтующих значений.",
      "mergeDeleteWarning": "Все комментарии и связанная история сохранятся. После этого дубликаты будут удалены: {count}. Это действие нельзя отменить.",
      "mergeInProgress": "Объединяем…",
      "mergeDetailsLoading": "Загружаем данные клиентов…",
      "mergeDetailsFailed": "Не удалось загрузить данные клиентов",
      "mergeFields": {
        "firstName": "Имя",
        "lastName": "Фамилия",
        "email": "Email",
        "email2": "Email 2",
        "phone": "Телефон",
        "phone2": "Телефон 2",
        "mobile": "Мобильный телефон",
        "birthdate": "Дата рождения",
        "gender": "Пол",
        "sin": "SIN",
        "passport": "Паспорт",
        "office": "Офис",
        "department": "Департамент",
        "agent": "Агент",
        "desk": "Деск",
        "team": "Команда",
        "status": "Статус",
        "salesAgent": "Sales-агент",
        "salesStatus": "Sales-статус",
        "salesDesk": "Sales-деск",
        "salesTeam": "Sales-команда",
        "retAgent": "Retention-агент",
        "retStatus": "Retention-статус",
        "retDesk": "Retention-деск",
        "retTeam": "Retention-команда",
        "language": "Язык",
        "country": "Страна",
        "address": "Адрес",
        "city": "Город",
        "state": "Область / штат",
        "credits": "Кредиты",
        "source": "Источник",
        "referral": "Реферал",
        "funnel": "Воронка",
        "affiliate": "Аффилиат",
        "registrationIp": "IP регистрации",
        "ext_id": "Внешний ID"
      },
      "columns": {
        "id": "ID",
        "active": "Активен",
        "office": "Офис",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "email": "Email",
        "phone": "Телефон",
        "salesStatus": "Sales Status",
        "retStatus": "Retention Status",
        "language": "Язык",
        "country": "Страна",
        "department": "Отдел",
        "agent": "Агент",
        "balance": "Баланс",
        "affiliate": "Партнёр",
        "lastComment": "Последний комментарий",
        "lastCommentDate": "Дата последнего комментария",
        "withdrawals": "Выводы",
        "currency": "Валюта",
        "totalDeposits": "Всего депозитов",
        "lastLogin": "Последний вход клиента",
        "registeredAt": "Дата регистрации",
        "registrationIp": "IP регистрации",
        "funnel": "Воронка",
        "additionalInfo": "Доп. информация"
      },
      "departments": {
        "sales": "Sales",
        "retention": "Retention"
      },
      "actions": {
        "assignTo": "Назначить",
        "blockLogin": "Заблокировать вход клиента",
        "unblockLogin": "Разблокировать вход клиента",
        "changeStatus": "Изменить статус",
        "changeOffice": "Изменить офис",
        "changeCountry": "Изменить страну",
        "changeLanguage": "Изменить язык",
        "deleteClients": "Удалить клиентов"
      }
    },
    "clientDetail": {
      "loading": "Загрузка...",
      "clientNotFound": "Клиент не найден",
      "loadFailed": "Не удалось загрузить клиента. Повторите попытку. Если ошибка повторяется, обратитесь к администратору.",
      "retry": "Повторить",
      "backToClients": "К списку клиентов",
      "active": "Активен",
      "blocked": "Заблокирован",
      "addCallback": "Добавить звонок",
      "changeStatus": "Изменить статус",
      "refresh": "Обновить",
      "personalInformation": "Личная информация",
      "acquisitionStatus": "Статус привлечения",
      "pinnedNotes": "Закреплённые заметки",
      "noPinnedNotes": "Нет закреплённых заметок",
      "comments": "Комментарии",
      "caseInfo": "Дело",
      "transactions": "Транзакции",
      "clientCabinet": "Кабинет клиента",
      "documents": "Документы",
      "personalInfo": "Личные данные",
      "newComment": "Новый комментарий",
      "noCommentsYet": "Комментариев пока нет",
      "loadingComments": "Загрузка комментариев...",
      "loadOlderComments": "Загрузить более старые комментарии",
      "configureVisibleFields": "Настроить видимые поля",
      "visibleFields": "Видимые поля",
      "dateOfBirth": "Дата рождения",
      "gender": "Пол",
      "phone": "Телефон",
      "secondPhone": "Второй телефон",
      "email": "Email",
      "secondEmail": "Второй email",
      "country": "Страна",
      "citizenship": "Гражданство",
      "language": "Язык",
      "city": "Город",
      "address": "Адрес",
      "affiliate": "Партнёр",
      "affiliateId": "ID партнёра",
      "source": "Источник",
      "referral": "Реферал",
      "funnel": "Воронка",
      "regIp": "Рег. IP",
      "callClient": "Позвонить клиенту",
      "inviteToConference": "Пригласить в конференцию / перевод",
      "endCall": "Завершить звонок",
      "sales": "Sales",
      "retention": "Retention",
      "notAssigned": "Не назначен",
      "desk": "Деск",
      "team": "Команда"
    },
    "transactions": {
      "loading": "Загрузка...",
      "filters": "Фильтры",
      "new": "Новый",
      "all": "Все",
      "clearFilters": "Очистить фильтры",
      "id": "ID",
      "clientId": "ID клиента",
      "type": "Тип",
      "amount": "Сумма",
      "currency": "Валюта",
      "status": "Статус",
      "description": "Описание",
      "date": "Дата",
      "dateFrom": "Дата с",
      "dateTo": "Дата по",
      "period": "Период",
      "filteredTotal": "Общая сумма по фильтру",
      "transactionsCount": "Транзакций",
      "periods": {
        "all": "За всё время",
        "today": "Сегодня",
        "week": "Эта неделя",
        "month": "Этот месяц",
        "date": "Конкретная дата",
        "range": "Промежуток"
      },
      "actions": "Действия",
      "edit": "Изменить",
      "delete": "Удалить",
      "showing": "Показано",
      "to": "-",
      "of": "из",
      "editTransaction": "Изменить транзакцию",
      "newTransaction": "Новая транзакция",
      "descriptionPlaceholder": "например, банковский перевод, оплата картой...",
      "update": "Обновить",
      "create": "Создать",
      "failedLoad": "Не удалось загрузить транзакции",
      "exported": "Экспортировано в {format}",
      "exportFailed": "Не удалось экспортировать",
      "transactionUpdated": "Транзакция обновлена",
      "transactionCreated": "Транзакция создана",
      "operationFailed": "Операция не выполнена",
      "confirmDelete": "Удалить эту транзакцию?",
      "transactionDeleted": "Транзакция удалена",
      "deleteFailed": "Не удалось удалить",
      "types": {
        "deposit": "Депозит",
        "withdrawal": "Вывод"
      },
      "statuses": {
        "completed": "Завершено",
        "pending": "В ожидании",
        "rejected": "Отклонено",
        "failed": "Ошибка"
      }
    },
    "affiliates": {
      "new": "Новый",
      "enabled": "Включён",
      "disabled": "Отключён",
      "searchPlaceholder": "Поиск по имени...",
      "loading": "Загрузка...",
      "empty": "Партнёры не найдены",
      "edit": "Изменить",
      "integrationInfo": "Интеграция",
      "copyToken": "Скопировать токен",
      "changeToken": "Изменить токен",
      "showing": "Показано",
      "to": "-",
      "of": "из",
      "entries": "записей",
      "editAffiliate": "Изменить партнёра",
      "addAffiliate": "Добавить партнёра",
      "name": "Имя",
      "office": "Офис",
      "namePlaceholder": "Введите имя партнёра",
      "officePlaceholder": "Выберите офис",
      "cancel": "Отмена",
      "save": "Сохранить",
      "integration": "Интеграция",
      "leadEndpoint": "Endpoint для лида",
      "requestBody": "Тело запроса (JSON)",
      "copyCurl": "Скопировать пример cURL",
      "response": "Ответ",
      "close": "Закрыть",
      "confirm": "Подтвердить",
      "changeTokenConfirm": "Вы уверены, что хотите изменить токен? Старый токен станет недействительным.",
      "failedLoad": "Не удалось загрузить партнёров",
      "failedLoadOffices": "Не удалось загрузить офисы",
      "nameRequired": "Введите имя",
      "officeRequired": "Выберите офис",
      "noOffices": "Нет доступных офисов",
      "updated": "Партнёр обновлён",
      "created": "Партнёр создан",
      "saveFailed": "Не удалось сохранить",
      "failed": "Ошибка",
      "tokenChanged": "Токен изменён",
      "tokenChangeFailed": "Не удалось изменить токен",
      "tokenCopied": "Токен скопирован",
      "copyFailed": "Не удалось скопировать",
      "copied": "Скопировано",
      "urlCopied": "URL скопирован",
      "curlCopied": "cURL скопирован",
      "columns": {
        "id": "ID",
        "name": "Имя",
        "office": "Офис",
        "status": "Статус",
        "apiToken": "API токен",
        "createdAt": "Создано",
        "actions": "Действия"
      }
    },
    "documents": {
      "uploadDocument": "Загрузить документ",
      "filters": "Фильтры",
      "documents": "документов",
      "searchLabel": "Поиск (клиент / email / файл)",
      "searchPlaceholder": "Введите и нажмите Enter...",
      "documentType": "Тип документа",
      "allTypes": "Все типы",
      "status": "Статус",
      "allStatuses": "Все статусы",
      "apply": "Применить",
      "clear": "Очистить",
      "client": "Клиент",
      "file": "Файл",
      "visibility": "Видимость",
      "reviewStatus": "Статус проверки",
      "uploadedBy": "Загрузил",
      "date": "Дата",
      "actions": "Действия",
      "loading": "Загрузка...",
      "empty": "Документов пока нет",
      "emptyPendingClient": "Ожидающие клиентские загрузки появятся здесь",
      "emptyPendingCrm": "Ожидающие загрузки CRM появятся здесь",
      "emptyClientUploads": "Клиентские загрузки появятся здесь",
      "emptyCrmUploads": "Загрузите документ кнопкой выше",
      "clientPortal": "Загрузка клиента",
      "crmUpload": "Загрузка CRM",
      "previewDocument": "Просмотр документа",
      "splitPdf": "Разделить PDF",
      "download": "Скачать",
      "approve": "Одобрить",
      "declineAndDelete": "Отклонить и удалить",
      "resetToPending": "Вернуть в ожидание",
      "delete": "Удалить",
      "of": "из",
      "uploadHint": "Прикрепите документ к профилю клиента",
      "fileHint": "(PDF, JPG, PNG - максимум 10 MB)",
      "clickToReplace": "нажмите, чтобы заменить",
      "dropFile": "Перетащите файл сюда или нажмите для выбора",
      "cancel": "Отмена",
      "upload": "Загрузить",
      "uploading": "Загрузка...",
      "searchClient": "Поиск клиента по имени или email...",
      "searching": "Поиск...",
      "sourceTabs": {
        "pending": "Ожидающие",
        "client": "Загрузки клиента",
        "crm": "Документы CRM"
      },
      "pendingSourceTabs": {
        "client": "Загрузки клиента",
        "crm": "Загрузки CRM"
      },
      "statuses": {
        "pending": "В ожидании",
        "approved": "Одобрено",
        "declined": "Отклонено"
      },
      "docTypes": {
        "Passport": "Паспорт",
        "Driver License": "Водительское удостоверение",
        "ID Front": "ID лицевая сторона",
        "ID Back": "ID обратная сторона",
        "Utility Bill": "Коммунальный счёт",
        "Bank Statement": "Банковская выписка",
        "Contract": "Договор",
        "Other": "Другое",
        "file": "Файл",
        "invoice": "Счёт",
        "case_file": "Файл дела"
      }
    },
    "calendar": {
      "loading": "Загрузка...",
      "today": "Сегодня",
      "tomorrow": "Завтра",
      "upcomingEvents": "Предстоящие события",
      "allAgents": "Все агенты",
      "workHoursSettings": "Настройки рабочих часов",
      "addEvent": "Добавить событие",
      "noUpcomingEvents": "Нет предстоящих событий",
      "more": "+{count} ещё",
      "allDay": "Весь день",
      "markDone": "Отметить выполненным",
      "markMissed": "Отметить пропущенным",
      "editEvent": "Изменить событие",
      "newEvent": "Новое событие",
      "title": "Название",
      "eventTitlePlaceholder": "Название события",
      "type": "Тип",
      "startDate": "Дата начала",
      "startTime": "Время начала",
      "endTime": "Время окончания",
      "clientName": "Имя клиента",
      "assignTo": "Назначить",
      "unassigned": "Не назначено",
      "description": "Описание",
      "status": "Статус",
      "optional": "Необязательно",
      "optionalNotes": "Дополнительные заметки...",
      "delete": "Удалить",
      "deleting": "Удаление...",
      "cancel": "Отмена",
      "save": "Сохранить",
      "saving": "Сохранение...",
      "workDayHours": "Рабочие часы",
      "workDayStart": "Начало рабочего дня",
      "workDayEnd": "Конец рабочего дня",
      "titleRequired": "Введите название",
      "eventUpdated": "Событие обновлено",
      "eventCreated": "Событие создано",
      "saveFailed": "Не удалось сохранить событие",
      "eventDeleted": "Событие удалено",
      "deleteFailed": "Не удалось удалить событие",
      "markedAs": "Отмечено как {status}",
      "statusUpdateFailed": "Не удалось изменить статус",
      "failedLoad": "Не удалось загрузить события",
      "startBeforeEnd": "Начало должно быть раньше конца",
      "workHoursSaved": "Рабочие часы сохранены",
      "views": {
        "month": "Месяц",
        "week": "Неделя",
        "day": "День",
        "list": "Список"
      },
      "types": {
        "call": "Звонок",
        "reminder": "Напоминание",
        "meeting": "Встреча",
        "other": "Другое"
      },
      "statuses": {
        "pending": "В ожидании",
        "done": "Выполнено",
        "missed": "Пропущено"
      },
      "months": {
        "0": "Январь",
        "1": "Февраль",
        "2": "Март",
        "3": "Апрель",
        "4": "Май",
        "5": "Июнь",
        "6": "Июль",
        "7": "Август",
        "8": "Сентябрь",
        "9": "Октябрь",
        "10": "Ноябрь",
        "11": "Декабрь"
      },
      "daysShort": {
        "0": "Пн",
        "1": "Вт",
        "2": "Ср",
        "3": "Чт",
        "4": "Пт",
        "5": "Сб",
        "6": "Вс"
      },
      "daysFull": {
        "0": "Понедельник",
        "1": "Вторник",
        "2": "Среда",
        "3": "Четверг",
        "4": "Пятница",
        "5": "Суббота",
        "6": "Воскресенье"
      }
    },
    "hierarchy": {
      "title": "Иерархия",
      "loading": "Загрузка иерархии...",
      "subtitle": "Перетаскивайте агентов между командами · Нажмите, чтобы свернуть/развернуть · Нажмите роль, чтобы изменить её",
      "offices": "офисы",
      "desks": "дески",
      "teams": "команды",
      "agents": "агенты",
      "people": "сотрудники",
      "refresh": "Обновить",
      "global": "Глобально",
      "noHead": "Нет руководителя",
      "empty": "Пусто",
      "dropHere": "Перетащите сюда",
      "clickChangeRole": "Нажмите, чтобы изменить роль",
      "emptyTitle": "Иерархии пока нет",
      "emptySubtitle": "Создайте офисы, дески, команды и назначьте пользователей.",
      "failedLoad": "Не удалось загрузить иерархию",
      "moveFailed": "Не удалось переместить",
      "failed": "Ошибка"
    },
    "offices": {
      "tabs": {
        "offices": "Офисы",
        "desks": "Дески",
        "teams": "Команды",
        "users": "Пользователи"
      },
      "new": "Новый",
      "newDesk": "Новый деск",
      "newTeam": "Новая команда",
      "active": "Активные",
      "inactive": "Неактивные",
      "filters": "Фильтры",
      "apply": "Применить",
      "clear": "Очистить",
      "loading": "Загрузка...",
      "entries": "записей",
      "name": "Название",
      "office": "Офис",
      "desk": "Деск",
      "department": "Отдел",
      "officeName": "Название офиса",
      "deskName": "Название деска",
      "teamName": "Название команды",
      "enterValue": "Введите значение",
      "allOffices": "Все офисы",
      "allDesks": "Все дески",
      "selectOffice": "Выберите офис",
      "selectOfficeFirst": "Сначала выберите офис",
      "notSpecified": "Не указано",
      "typeOfficeName": "Введите название офиса",
      "typeDeskName": "Введите название деска",
      "typeTeamName": "Введите название команды",
      "noOffices": "Офисы не найдены",
      "noDesks": "Дески не найдены",
      "noTeams": "Команды не найдены",
      "editOffice": "Изменить офис",
      "addOffice": "Добавить офис",
      "editDesk": "Изменить деск",
      "addDesk": "Добавить деск",
      "editTeam": "Изменить команду",
      "addTeam": "Добавить команду",
      "cancel": "Отмена",
      "save": "Сохранить",
      "saveFailed": "Не удалось сохранить",
      "deleteFailed": "Не удалось удалить",
      "failedLoadOffices": "Не удалось загрузить офисы",
      "failedLoadDesks": "Не удалось загрузить дески",
      "failedLoadTeams": "Не удалось загрузить команды",
      "officeNameRequired": "Введите название офиса",
      "deskNameRequired": "Введите название деска",
      "teamNameRequired": "Введите название команды",
      "createDeskFirst": "Сначала создайте и выберите деск",
      "officeUpdated": "Офис обновлён",
      "officeCreated": "Офис создан",
      "officeDeleted": "Офис удалён",
      "deskUpdated": "Деск обновлён",
      "deskCreated": "Деск создан",
      "deskDeleted": "Деск удалён",
      "teamUpdated": "Команда обновлена",
      "teamCreated": "Команда создана",
      "teamDeleted": "Команда удалена",
      "updatedOfficeTeams": "Офис обновлён для команд: {count}",
      "confirmDeleteOffice": "Удалить офис \"{name}\"?",
      "confirmDeleteDesk": "Удалить деск \"{name}\"?",
      "confirmDeleteTeam": "Удалить команду \"{name}\"?",
      "columns": {
        "id": "ID",
        "name": "Название",
        "usersCount": "Пользователи #",
        "clientsCount": "Клиенты #",
        "creationDate": "Дата создания",
        "office": "Офис",
        "created": "Создано",
        "department": "Отдел",
        "desk": "Деск",
        "actions": "Действия"
      }
    },
    "settings": {
      "tabs": {
        "statuses": "Статусы",
        "telephony": "Подключения телефонии",
        "permissions": "Права доступа",
        "whitelist": "Белый список IP",
        "blacklist": "Чёрный список IP",
        "sessions": "Сессии",
        "logs": "Логи"
      },
      "statuses": {
        "dragPrefix": "Перетащите",
        "dragSuffix": "для изменения порядка",
        "addStatus": "Добавить статус",
        "statusesTitle": "статусы",
        "loading": "Загрузка...",
        "empty": "Статусов пока нет",
        "default": "По умолчанию",
        "statusesCount": "статусов",
        "editStatus": "Изменить статус",
        "newStatus": "Новый статус",
        "name": "Название",
        "namePlaceholder": "например, Follow UP",
        "color": "Цвет",
        "setAsDefault": "Сделать статусом по умолчанию",
        "cancel": "Отмена",
        "save": "Сохранить",
        "failedLoad": "Не удалось загрузить статусы",
        "orderSaveFailed": "Не удалось сохранить порядок",
        "nameRequired": "Введите название",
        "statusUpdated": "Статус обновлён",
        "statusCreated": "Статус создан",
        "statusSaveFailed": "Не удалось сохранить статус",
        "confirmDelete": "Удалить статус \"{name}\"?",
        "deleted": "Удалено",
        "deleteFailed": "Не удалось удалить",
        "columns": {
          "badge": "Бейдж",
          "name": "Название",
          "default": "По умолчанию",
          "actions": "Действия"
        }
      }
    },
    "users": {
      "all": "Все",
      "active": "Активные",
      "inactive": "Неактивные",
      "new": "Новый",
      "filters": "Фильтры",
      "users": "пользователей",
      "search": "Поиск",
      "searchPlaceholder": "Имя или email",
      "email": "Email",
      "role": "Роль",
      "allRoles": "Все роли",
      "office": "Офис",
      "allOffices": "Все офисы",
      "desk": "Деск",
      "allDesks": "Все дески",
      "team": "Команда",
      "allTeams": "Все команды",
      "selectOffice": "Выберите офис",
      "selectDesk": "Выберите деск",
      "selectTeam": "Выберите команду",
      "selectParentFirst": "Сначала выберите родителя",
      "apply": "Применить",
      "clear": "Очистить",
      "loading": "Загрузка...",
      "noUsers": "Пользователи не найдены",
      "enabled": "Включён",
      "activate": "Активировать",
      "deactivate": "Деактивировать",
      "showing": "Показано",
      "of": "из",
      "editUser": "Изменить пользователя",
      "newUser": "Новый пользователь",
      "name": "Имя",
      "fullName": "Полное имя",
      "password": "Пароль",
      "newPassword": "Новый пароль",
      "keepPassword": "Оставьте пустым, чтобы сохранить текущий пароль",
      "telephonyAccess": "Доступ к телефонии",
      "cancel": "Отмена",
      "save": "Сохранить",
      "saving": "Сохранение...",
      "failedLoad": "Не удалось загрузить пользователей",
      "nameEmailRequired": "Введите имя и email",
      "createTeamFirst": "Сначала создайте и выберите команду для агента",
      "passwordRequired": "Введите пароль",
      "saveFailed": "Не удалось сохранить",
      "userUpdated": "Пользователь обновлён",
      "userCreated": "Пользователь создан",
      "userActivated": "Пользователь активирован",
      "userDeactivated": "Пользователь деактивирован",
      "statusUpdateFailed": "Не удалось изменить статус",
      "confirmDelete": "Удалить пользователя {name}?",
      "userDeleted": "Пользователь удалён",
      "deleteFailed": "Не удалось удалить",
      "columns": {
        "id": "ID",
        "userName": "Имя пользователя",
        "email": "Email",
        "role": "Роль",
        "office": "Офис",
        "desk": "Деск",
        "team": "Команда",
        "telephony": "Телефония",
        "clients": "Клиенты",
        "lastLogin": "Последний вход",
        "status": "Статус",
        "actions": "Действия"
      }
    },
    "placeholder": {
      "underConstruction": "Эта страница в разработке. Функция скоро появится!"
    }
  }
};
